import React from 'react'
// Local
import { CONDITION } from '../../../constant'
import { formatIcd10Code } from '../../common/formatUtils'
import { EncounterConditionDisplay } from '../../authenticated/types'
import If from '../../common/if'

/**
 * Provides a component that shows a read-only view of CDI potential condition
 * tag properties.
 *
 * @param condition Condition entity
 */

type Props = {
  condition: EncounterConditionDisplay
}

function CdiPotentialConditionTagsRead(
  props: Props
) {
  const { condition } = props
  const cdiTags = condition.cdiTags
    ? condition.cdiTags
    : null
  const isNetNew = !!cdiTags && cdiTags.netNewStatusCode === CONDITION.NET_NEW
  const isKnownPotential = !!cdiTags && cdiTags.knownPotentialStatusCode === CONDITION.KNOWN_POTENTIAL
  const expectedDiagnosis = !!cdiTags && cdiTags.expectedDiagnosis
    ? cdiTags.expectedDiagnosis
    : null
  return (
    <div>
      <If isTrue={ isNetNew }>
        <div>Condition marked as <strong>Net New</strong></div>
      </If>
      <If isTrue={ isKnownPotential }>
        <div>Condition marked as <strong>Known Potential</strong></div>
      </If>
      <If isTrue={ !!expectedDiagnosis }>
        <div>Expected Diagnosis: <strong>{ formatIcd10Code(expectedDiagnosis) }</strong></div>
      </If>
    </div>
  )
}

export default CdiPotentialConditionTagsRead
